module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAAvklEQVQokaXSr4oCURyG4TNM0aTRYJxiNNrsRq9h7kNvw81W9xYW9gYEoyabYLEMCMpj+QnD4u6oe+Ar35/3cOBkWKaUtlmWzdI/DuYppSKhxBUL5G+A8theUd7NKc74RPsFWDs2Z0x/hmOc8I3uE7BudE8Y/1Ya4oAN+n/A+tE5YNh0c4Ed9hg8yAeR7VA0veQ+6mGNI0Y1fxTeGr2nYLVxB1+oMAlV4XVegtWgLaxwCa3QegtWg+b4CDX+0xsy5+7ugMfSKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/stare.png
// module id = ZiIQ
// module chunks = 1